import React from 'react';

const ViewCompany = React.lazy(() =>
  import('features/company/pvt-components/view')
);

const ViewConversation = React.lazy(() => import('features/conversation/view'));
const ViewLead = React.lazy(() => import('features/lead/pvt-components/view'));
const CreateChatBot = React.lazy(() =>
  import('features/chatbot/pvt-components/CreateChatBot')
);
const ViewReport = React.lazy(() => import('pages/portal/report/view'));
const ViewProvision = React.lazy(() => import('pages/portal/provision/view'));
const WidgetSettings = React.lazy(() =>
  import('features/settings/pvt-components/settings-detail')
);
const ChatBotDetail = React.lazy(() =>
  import('features/chatbot/pvt-components/ChatBotDetail')
);
const ChatBotEdit = React.lazy(() =>
  import('pages/portal/chatBot/chatBotEdit')
);
const ChatBotTemplate = React.lazy(() =>
  import('features/chatbot/pvt-components/BotTemplate')
);
const VoiceAgentDetails = React.lazy(() =>
  import('pages/portal/voiceAgents/details')
);
const CallHistoryDetails = React.lazy(() =>
  import('pages/portal/voiceAgents/callHistoryDetails')
);
const AgentCallHistory = React.lazy(() =>
  import('pages/portal/voiceAgents/callHistoryGrid')
);
const AgentDetail = React.lazy(() =>
  import('features/agents/pvt-components/AgentDetail')
);

const nestedRoutes = [
  {
    path: '/portal/chatbot/templates',
    component: props => <ChatBotTemplate {...props} />,
    name: 'chatbot',
    exact: false
  },
  {
    path: '/portal/chatbot/:id',
    component: props => <ChatBotEdit {...props} />,
    name: 'chatbot',
    exact: true
  },
  {
    path: '/portal/settings/:id',
    component: props => <ViewCompany {...props} />,
    exact: true
  },
  {
    path: '/portal/chatbot/create/:type',
    component: props => <CreateChatBot {...props} />,
    name: 'chatbot',
    secondKey: 'create',
    exact: false
  },
  {
    path: '/portal/chatbot/:id/:type?',
    component: props => <ChatBotDetail {...props} />,
    name: 'chatbot',
    exact: false
  },

  {
    path: '/portal/conversations/:id',
    component: props => <ViewConversation {...props} />,
    exact: true
  },
  {
    path: '/portal/leads/:id',
    component: props => <ViewLead {...props} />,
    exact: true
  },
  {
    path: '/portal/report/:id',
    component: props => <ViewReport {...props} />,
    exact: true
  },
  {
    path: '/portal/onboarding/:id',
    component: props => <ViewProvision {...props} />,
    exact: true
  },
  {
    path: '/portal/settings/:companyId/:type?',
    name: 'settings-comany-details',
    title: 'Company settings',
    component: props => <WidgetSettings {...props} />,
    exact: false
  },
  {
    path: '/portal/agents/history/:id',
    name: 'agentscallhistory',
    title: 'Agent History Details',
    component: props => <CallHistoryDetails {...props} />,
    exact: true
  },
  {
    path: '/portal/agents/history',
    name: 'agentscallhistory',
    title: 'Agents Call History',
    component: props => <AgentCallHistory {...props} />,
    exact: true
  },
  {
    path: '/portal/agents/:id',
    component: props => <VoiceAgentDetails {...props} />,
    exact: true
  },
  {
    path: '/portal/agents/:id/:type?',
    component: props => <AgentDetail {...props} />,
    exact: false
  }
];

export default nestedRoutes;
